import styled from 'styled-components';

export const SameLine = styled.div`
  display: flex;
`;
